import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { CODE_SESSION_LENGTH } from '~/config/global.config';
import logo from '~/assets/img/logo-unboared.png';
import { Input } from '~/components/ui/input';
import { Button } from '~/components/ui/button';

import styles from './GamepadAccess.module.css';

export const FONT_SIZE = 15;

export function GamepadAccess() {
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState('');

    const checkCode = (code: string) => {
        const isnum = /^\d+$/.test(code);
        return isnum && code.length === CODE_SESSION_LENGTH;
    };

    const submit = (e: any) => {
        e.preventDefault();
        const form = e.target;
        const formData = new FormData(form);
        const code = formData.get('sessionCode') as string;
        if (checkCode(code)) {
            navigate(`/gamepad/${code}`);
        } else {
            form.reset();
            setErrorMessage('Invalid code');
        }
    };

    const rmErrorMessage = () => {
        setErrorMessage('');
    };

    return (
        <div className={styles.container}>
            {/* Displays the header with the logo */}
            <div className={styles.header}>
                <img className={styles.logo} src={logo} alt="unboared logo" />
            </div>
            {/* Displays the form */}
            <form className={styles.content} onSubmit={submit}>
                <h1>Ready to play?</h1>
                {errorMessage && <p className={styles.error}>{errorMessage}</p>}
                <p className={styles.label}>Type the session code</p>
                <Input
                    className={styles.input}
                    containerClassName={styles.inputContainer}
                    id="sessionCode"
                    placeholder={'0'.repeat(CODE_SESSION_LENGTH)}
                    onSelect={rmErrorMessage}
                    error={errorMessage.length > 0}
                />
                <Button className={styles.joinButton} type="submit" textPreset="large">
                    Join the game
                </Button>
            </form>
        </div>
    );
}
